const func = ($target) => {
    var x = setInterval(function() {
        let date = $target.find('#date').html()
        var countDownDate = new Date(date).getTime();
        var hr = $target.find('#hours').html();
        var now = new Date().getTime();

        var distance = countDownDate - now;

        remainingTime(distance)

        if (distance < 0) {
            clearInterval(x)
            countDown(hr)
        }
    }, 1000);
    function remainingTime(distance) {
        var days = formatWithLeadingZeros(Math.floor(distance / (1000 * 60 * 60 * 24)),'d');
        var hours = formatWithLeadingZeros(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),'hh');
        var minutes = formatWithLeadingZeros(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),'m');
        var seconds = formatWithLeadingZeros(Math.floor((distance % (1000 * 60)) / 1000),'s');
    }
    function formatWithLeadingZeros(number,time) {
        if (number.toString().length < 2) {
            number = '0' + number
        }
        number = number.toString().split('');
        $target.find('.'+time+'0').text(number[0]);
        $target.find('.'+time+'1').text(number[1]);
    }
    function updateCountdown(targetTime,interval,hr) {
        var now = new Date();
        var timeRemaining = targetTime - now.getTime();
        var moduleId = $target.find('#moduleId').html();

        if (timeRemaining <= 0) {
            clearInterval(interval);
            localStorage.removeItem("countDown-"+moduleId);
            countDown(hr);
        } else {
            remainingTime(timeRemaining)
        }
    }

    function countDown(hr) {
        var duration = hr * 60 * 60 * 1000; // Convert hours to milliseconds
        var startTime = new Date().getTime();
        var targetTime = startTime + duration;
        var moduleId = $target.find('#moduleId').html();

        var storedCountdown = localStorage.getItem("countDown-"+moduleId);
        if (storedCountdown) {
            var storedData = JSON.parse(storedCountdown);
            targetTime = storedData.targetTime;
        } else {
            if(!hr) {
                remainingTime(0)
            }
        }

        updateCountdown(targetTime,interval,hr);

        var interval = setInterval(function() {
            updateCountdown(targetTime,interval,hr);
        }, 1000);

        var countdownData = {
            targetTime: targetTime
        };
        localStorage.setItem("countDown-"+moduleId, JSON.stringify(countdownData));
    }
}
export default func;
